 // Debounce function to limit the rate at which a function can fire
 function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  window.addEventListener('DOMContentLoaded', function () {
    setEqualHeight('.flip-front-label');

    // Debounced resize event listener
    window.addEventListener(
      'resize',
      debounce(function () {
        setEqualHeight('.flip-front-label');
      }, 250)
    ); // 250ms debounce time
  });

  function setEqualHeight(selector) {
    var elements = document.querySelectorAll(selector);
    var maxHeight = 0;

    elements.forEach(function (element) {
      element.style.height = 'auto'; // Reset height to auto before calculating new height
      var height = element.clientHeight;
      maxHeight = Math.max(maxHeight, height);
    });

    elements.forEach(function (element) {
      element.style.height = maxHeight + 'px';
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    new Splide('#ingredients-slider', {
      perPage: 3,
      perMove: 1,
      gap: '20px',
      pagination: false,
      arrows: false,
      breakpoints: {
        767: {
          perPage: 1,
          perMove: 1,
          pagination: true,
          padding: { right: '4rem' },
        },
      },
    }).mount();
  });

  (function (modal) {
    'use strict';
    const dom = {};
    const focusableElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
    let focusableContent;
    let firstFocusableElement;
    let lastFocusableElement;

    const cacheDom = () => {
      dom.triggers = document.querySelectorAll('.modalToggler');
      dom.togglers = document.querySelectorAll('.toggler');
      dom.modals = document.querySelectorAll('.modal'); // Assuming '.modal' is the class for modal elements
    };

    const bindUIActions = () => {
      dom.triggers?.forEach((trigger) => {
        trigger.addEventListener('click', (event) => toggleModal(event));
        trigger.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            toggleModal(event);
          }
        });
      });

      dom.togglers?.forEach((toggler) => {
        toggler.addEventListener('click', (event) => toggleElement(event));
        toggler.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            toggleElement(event);
          }
        });
      });

      // Close modal when clicking outside
      dom.modals?.forEach((modal) => {
        modal.addEventListener('click', (event) => {
          if (event.target === modal) {
            closeModal(modal);
          }
        });
      });

      // Add keyboard event listener for Escape key
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          const activeModal = document.querySelector('.modal.is--active');
          if (activeModal) {
            closeModal(activeModal);
          }
        }
      });
    };

    const toggleModal = (event) => {
      const trigger = event.currentTarget;
      const modalTargetId = trigger.dataset.target;
      const targetProductTitle = trigger.dataset.productTitle;
      const modalTarget = document.getElementById(modalTargetId);

      if (targetProductTitle) {
        const modalProductTitle = modalTarget.querySelector('.js-modal-product-title');
        if (modalProductTitle) modalProductTitle.innerHTML = targetProductTitle;
      }

      if (modalTarget.classList.contains('is--active')) {
        closeModal(modalTarget);
      } else {
        openModal(modalTarget);
      }
    };

    const openModal = (modal) => {
      modal.classList.add('is--active');
      document.body.classList.add('overflow--hidden');
      modal.setAttribute('aria-hidden', 'false');

      // Set focus to the first focusable element
      focusableContent = modal.querySelectorAll(focusableElements);
      firstFocusableElement = focusableContent[0];
      lastFocusableElement = focusableContent[focusableContent.length - 1];
      firstFocusableElement.focus();

      // Add event listener for trapping focus
      modal.addEventListener('keydown', trapFocus);
    };

    const closeModal = (modal) => {
      modal.classList.remove('is--active');
      document.body.classList.remove('overflow--hidden');
      modal.setAttribute('aria-hidden', 'true');

      // Remove event listener for trapping focus
      modal.removeEventListener('keydown', trapFocus);

      // Return focus to the trigger element
      const trigger = document.querySelector(`[data-target="${modal.id}"]`);
      if (trigger) trigger.focus();
    };

    const toggleElement = (event) => {
      const toggler = event.currentTarget;
      const targetId = toggler.dataset.target;
      const targetElement = document.getElementById(targetId);
      targetElement.classList.toggle('is--open');

      const isOpen = targetElement.classList.contains('is--open');
      toggler.setAttribute('aria-expanded', isOpen.toString());
      targetElement.setAttribute('aria-hidden', (!isOpen).toString());
    };

    const trapFocus = (event) => {
      if (event.key === 'Tab') {
        if (event.shiftKey) {
          if (document.activeElement === firstFocusableElement) {
            event.preventDefault();
            lastFocusableElement.focus();
          }
        } else {
          if (document.activeElement === lastFocusableElement) {
            event.preventDefault();
            firstFocusableElement.focus();
          }
        }
      }
    };

    const init = () => {
      cacheDom();
      bindUIActions();

      // Set initial ARIA attributes
      dom.triggers?.forEach((trigger) => {
        const targetId = trigger.dataset.target;
        const target = document.getElementById(targetId);
        if (target) {
          target.setAttribute('aria-hidden', 'true');
          trigger.setAttribute('aria-haspopup', 'dialog');
          trigger.setAttribute('aria-expanded', 'false');
        }
      });
    };

    modal.init = init;
  })((window.modal = window.modal || {}));

  // Call init when the DOM is fully loaded
  document.addEventListener('DOMContentLoaded', function () {
    window.modal.init();
  });